import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';

export const Root = styled.div`
  position: relative;
  width: 454px;
  height: 101px;
  border-radius: 10px;
  border: solid 1px #bdbdbd;
  background-color: #fff;
  display: flex;
`;

export const InfoContainer = styled.div`
  width: 213px;
  padding: 22px 0px 26px 0px;
`;
export const Texto = styled.div`
  font-family: Rubik;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
  margin-left: 27px;
  margin-bottom: 7px;
`;

export const NoReviewsText = styled.div `
  font-family: Rubik;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #b7332b;
  margin-left: 27px;
  margin-bottom: 7px;
`;

export const StarsContainer = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Image = styled.div`
  cursor: pointer;
  margin-left: 9px;
`;
